const FacFnSort = {
  scalar: (field, isAsc) => {
    
    const vSort1 = isAsc ? 1 : -1;
    const vSort2 = isAsc ? -1 : 1;
    
    return (k1, k2) => {
      
      const a = k1[field];
      const b = k2[field];
      
      if (a === b) {
        return 0;
      }
      
      return a > b ? vSort1 : vSort2;
    }
  }
}

export default FacFnSort;